import { Status, StatusProps, Text, Box } from '@cad-arc';
import { globalAttributes } from '../global-attributes';
import { CommonSize } from '../helpers/utils';

const hospitalStatusMap: Record<number, StatusProps['status']> = {
    [globalAttributes.hospitalStatusGlobal.OPEN]: 'positive',
    [globalAttributes.hospitalStatusGlobal.CONDITIONAL]: 'attention',
    [globalAttributes.hospitalStatusGlobal.DIVERT]: 'negative',
};

export function HospitalStatusTag({
    hospitalStatusGlobalAttributeId,
    hospitalStatus,
    size,
}: {
    hospitalStatusGlobalAttributeId?: number;
    hospitalStatus?: string;
    size?: CommonSize;
}) {
    if (!hospitalStatus) {
        return null;
    }

    return (
        // The box is needed to because in dark mode, the bg of the status component is semi-transparent.  When hovering over the row,
        // you can barely see the status anymore due to the row bg turning light blue.  Here we add a dark background behind the status
        // so the status bg color appears static.
        <Box bg="surface.canvas" display="inline-flex" borderRadius="sm">
            <Status
                status={
                    hospitalStatusGlobalAttributeId
                        ? hospitalStatusMap[hospitalStatusGlobalAttributeId]
                        : 'neutral'
                }
            >
                <Text fontSize={size} color="inherit">{hospitalStatus}</Text>
            </Status>
        </Box>
    );
}
